import { push } from 'connected-react-router'

export const getPartners = () => ({
  type: 'FETCH_MILEAGE_PARTNERS',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: `/v1/stores/mileage`
    }
  }
})

export const convertPointsToMiles = (supplierId, points) => ({
  type: 'FETCH_POINTS_TO_MILES',
  payload: {
    client: 'mileageApi',
    request: {
      method: 'get',
      url: `/mileage-api/v1/calculators/pointsToMiles/${supplierId}/${points}`
    }
  }
})

export const clearCalculator = () => ({
  type: 'CLEAR_CALCULATOR'
})

export const disableRedemptionButton = (value) => ({
  type: 'REDEMPTION_DISABLE_BUTTON',
  value
})

export const closeErrorMileage = () => ({
  type: 'REDEMPTION_MILEAGE_CLOSE_ERROR'
})

export const errorCpfMileage = () => ({
  type: 'REDEMPTION_MILEAGE_ERROR_CPF'
})

export const errorBalanceRedemption = () => ({
  type: 'REDEMPTION_MILEAGE_ERROR_BALANCE'
})

export const errorMinimunRedemption = MinimumRedemption => ({
  type: 'REDEMPTION_MILEAGE_MINIMUN',
  MinimumRedemption
})

export const errorMinimunBalanceRedemption = MinimunBalance => ({
  type: 'REDEMPTION_MILEAGE_MINIMUN_BALANCE',
  MinimunBalance
})

export const authorizeWithTokenMileage = client => (
  OrderId,
  Token,
  OrderMileageId,
  VendorId,
  lastTry
) => {
  return (dispatch, getState) => {
    const {
      oidc: { user }
    } = getState()
    if (!user) {
      dispatch(push('/auth/login'))
    } else {
      dispatch({ type: 'MILEAGE_WITH_TOKEN', lastTry, orderId: OrderId })
    }

    const handleSuccess = response => {
      dispatch({ type: 'REDEMPTION_MILEAGE_SUCCESS' })
      dispatch(
        push(`/services/confirmation/${response.data.order.liveOrderId}`)
      )
    }

    const handleError = error => {
      const { response } = error
      if (response.status === 401) {
        if (response.data.description === 'AuthenticationRequired') {
          dispatch({
            type: 'TOKEN_INVALID_MILEAGE',
            orderId: response.data.orderId,
            orderMileageId: response.data.orderMileageId,
            lastTry
          })
        }
      } else {
        dispatch({ type: 'REDEMPTION_MILEAGE_FAIL', error })
      }
    }

    client
      .post(
        `/mileage-api/v1/orders/withToken?orderId=${OrderId}&token=${Token}&orderMileageId=${OrderMileageId}`,
        null,
        {
          headers: { 'X-Mileage-VendorId': VendorId }
        }
      )
      .then(handleSuccess)
      .catch(handleError)
  }
}

export const mileageRedemption = client => (order, supplierId) => {
  return (dispatch, getState) => {
    const {
      oidc: { user }
    } = getState()
    if (!user) {
      dispatch(push('/auth/login'))
    } else {
      dispatch({ type: 'REDEMPTION_MILEAGE' })
    }

    const handleSuccess = response => {
      dispatch({ type: 'REDEMPTION_MILEAGE_SUCCESS' })
      dispatch(
        push(`/services/confirmation/${response.data.order.liveOrderId}`)
      )
    }

    const handleError = error => {
      const { response } = error
      if (response.status === 401 || response.status === 406) {
        if (response.data.description === 'AuthenticationRequired') {
          dispatch({
            type: 'AUTHORIZATION_REQUIRED_MILEAGE',
            orderId: response.data.orderId,
            orderMileageId: response.data.orderMileageId
          })
        }

        if (response.data.status === 'OnBoardingRequired') {
          dispatch({
            type: 'ONBOARDING_REQUIRED_MILEAGE'
          })
        }
      } else {
        dispatch({ type: 'REDEMPTION_MILEAGE_FAIL', error })
      }
    }

    client
      .post('/mileage-api/v1/orders/redemption', order, {
        headers: { 'X-Mileage-VendorId': supplierId }
      })
      .then(handleSuccess)
      .catch(handleError)
  }
}

export const getMileageConfigurations = (catalogId, supplierId) => ({
  type: 'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN',
  payload: {
    client: 'mileageApi',
    request: {
      method: 'get',
      url: `/mileage-api/v1/configurations/CampaignConfig?catalogId=${catalogId}&supplierId=${supplierId}`
    }
  },
  supplierId
})

export const filterPartnerMileage = (partners, isMileagePartners) => {
  const TYPE = {
    DISTINCT_PARTNERS: 77
  }

  if (isMileagePartners) {
    return partners && partners.filter(x => x.priority !== TYPE.DISTINCT_PARTNERS)
  } else {
    return partners && partners.filter(x => x.priority === TYPE.DISTINCT_PARTNERS)
  }
}

export const getPartnersWithConfigurations = client => (catalogId) => {
  return (dispatch, _) => {
    dispatch({ type: 'FETCH_MILEAGE_PARTNERS' })
    dispatch({ type: 'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN/CLOSE' })

    const handleSuccess = async data => {
      var count = (data.length - 1)

      dispatch({ type: 'FETCH_MILEAGE_PARTNERS_SUCCESS', data })

      data.forEach((item, index) => {
        dispatch(getMileageConfigurations(catalogId, item.vendorId))

        if (index === count) {
          setTimeout(() => {
            dispatch({ type: 'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN/OPEN' })
          }, 3000)
        }
      })
    }

    const handleFail = error => {
      dispatch({ type: 'FETCH_MILEAGE_PARTNERS_FAIL', message: error })
    }

    client
      .get(`/v1/stores/mileage`)
      .then(rensponse => {
        handleSuccess(rensponse.data)
      })
      .catch(handleFail)
  }
}
export const closeModalShowError = error => ({
  type: 'CLOSE_MODAL_SHOW_ERROR',
  error
})

export default (client, clientMkp) => ({
  getPartners,
  convertPointsToMiles,
  clearCalculator,
  mileageRedemption: mileageRedemption(client),
  authorizeWithTokenMileage: authorizeWithTokenMileage(client),
  getPartnersWithConfigurations: getPartnersWithConfigurations(clientMkp),
  closeErrorMileage,
  errorBalanceRedemption,
  errorMinimunRedemption,
  errorMinimunBalanceRedemption,
  errorCpfMileage,
  getMileageConfigurations,
  closeModalShowError,
  disableRedemptionButton
})



// WEBPACK FOOTER //
// ./src/features/Services/Mileage/actions.js